package com.flowyride.feature.account.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.text.input.ImeAction
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.flowyride.core.designsystem.component.FlowyTextField
import com.flowyride.core.designsystem.component.FlowyTextFieldKind
import com.flowyride.feature.account.ChangePasswordAction
import com.flowyride.feature.account.ChangePasswordViewModel
import com.flowyride.feature.account.resources.Res
import com.flowyride.feature.account.resources.cancel
import com.flowyride.feature.account.resources.change_password_done
import com.flowyride.feature.account.resources.close
import com.flowyride.feature.account.resources.confirm
import com.flowyride.feature.account.resources.field_current_password
import com.flowyride.feature.account.resources.field_replacement_password
import com.flowyride.feature.account.resources.menu_change_password
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun ChangePasswordDialog(onDismiss: () -> Unit, viewModel: ChangePasswordViewModel = koinViewModel()) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val close = {
        viewModel.onAction(ChangePasswordAction.Reset)
        onDismiss()
    }
    AlertDialog(
        onDismissRequest = close,
        title = { Text(stringResource(Res.string.menu_change_password)) },
        text = {
            if (state.done) {
                Text(stringResource(Res.string.change_password_done))
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    FlowyTextField(
                        value = state.currentPassword,
                        onValueChange = { viewModel.onAction(ChangePasswordAction.CurrentChanged(it)) },
                        label = stringResource(Res.string.field_current_password),
                        kind = FlowyTextFieldKind.CurrentPassword,
                        imeAction = ImeAction.Next,
                        modifier = Modifier.fillMaxWidth(),
                    )
                    FlowyTextField(
                        value = state.newPassword,
                        onValueChange = { viewModel.onAction(ChangePasswordAction.NewChanged(it)) },
                        label = stringResource(Res.string.field_replacement_password),
                        kind = FlowyTextFieldKind.NewPassword,
                        imeAction = ImeAction.Done,
                        onImeAction = { viewModel.onAction(ChangePasswordAction.Submit) },
                        modifier = Modifier.fillMaxWidth(),
                    )
                    state.error?.let { Text(stringResource(it), color = MaterialTheme.colorScheme.error) }
                }
            }
        },
        confirmButton = {
            if (state.done) {
                TextButton(onClick = close) { Text(stringResource(Res.string.close)) }
            } else {
                TextButton(
                    onClick = { viewModel.onAction(ChangePasswordAction.Submit) },
                    enabled = !state.busy,
                ) { Text(stringResource(Res.string.confirm)) }
            }
        },
        dismissButton = {
            if (!state.done) TextButton(onClick = close) { Text(stringResource(Res.string.cancel)) }
        },
    )
}
